import whitelabelConfigs from '../../whitelabel/whitelabel-config.json';

export const ESPIRA_ICON_CONFIG = {
    SPIRE_PORTALEN_COLOR_GREEN: '#96C120',
    SPIRE_PORTALEN_COLOR_RED: '#CB333B',
    SPIRE_PORTALEN_COLOR_WHITE: '#FFFFFF',
};

export type Whitelabel = keyof typeof whitelabelConfigs;

export type Assets = {
    logoSidebar?: string;
    logoTopbar?: string;
    logoGetStarted?: string;
    logoLogin?: string;
    signInAppLogin?: string;
    loginBackground?: string;
    logoPrint?: string;
};

// Dynamically extract the asset keys
export type AssetKey = keyof Assets;

// A helper function to get the full whitelabel config
export const getWhitelabelConfig = (id: Whitelabel) => whitelabelConfigs[id];

// A helper function to get a config entry from a whitelabel config
export const getConfig = (id: Whitelabel, key: keyof typeof whitelabelConfigs[typeof id] | string) =>
    getWhitelabelConfig(id)?.[key];

// A helper function to get an asset from a whitelabel config
export const getAsset = (id: Whitelabel, key: AssetKey): string | undefined => {
    return getConfig(id, 'assets')?.[key];
};

export const WhitelabelUrl: Record<Whitelabel, string> = Object.keys(whitelabelConfigs).reduce((acc, id) => {
    acc[id as Whitelabel] = getConfig(id as Whitelabel, 'domain') as string;
    return acc;
}, {} as Record<Whitelabel, string>);

export const WhitelabelMobileUrl: Record<Whitelabel, string> = Object.keys(whitelabelConfigs).reduce((acc, id) => {
    acc[id as Whitelabel] = getConfig(id as Whitelabel, 'app_url_scheme') as string;
    return acc;
}, {} as Record<Whitelabel, string>);
